<template>
	<nav id="vueEventsPluginPagination" aria-label="Events Page Navigation" class="mt-3">

		<pagination-loading v-if="loading" />

		<ul class="pagination pagination-sm justify-content-center" :class="{ 'd-none': useInfiniteScroll }">
			<li class="page-item">
				<a class="page-link" :class="{ disabled: 1 === currentPage }" href="#" aria-label="Previous"
					v-on:click.prevent.stop="triggerPageChangeEvent(this.currentPage - 1)">
					<span aria-hidden="true">&laquo;</span>
				</a>
			</li>
			<li v-for="(n, index) in totalPages" :key="index" class="page-item" :class="{ active: n === currentPage }">
				<a class="page-link" :class="{ disabled: n === currentPage }" href="#"
					v-on:click.prevent.stop="triggerPageChangeEvent(n)">
					{{ n }}
				</a>
			</li>
			<li class="page-item">
				<a class="page-link" :class="{ disabled: totalPages === currentPage }" href="#" aria-label="Next"
					v-on:click.prevent.stop="triggerPageChangeEvent(this.currentPage + 1)">
					<span aria-hidden="true">&raquo;</span>
				</a>
			</li>
		</ul>

	</nav>
</template>

<script>
import PaginationLoading from '@/components/PaginationLoading.vue'

export default {
	name: 'EventPagination',
	props: {
		currentPage: Number,
		totalPages: Number,
		loading: Boolean,
		useInfiniteScroll: Boolean
	},
	components: {
		PaginationLoading
	},
	emits: ['pageChanged', 'pageAppend'],
	data() {
		return {
			scrollTriggerElement: null,
			scrollBuffer: 430
		}
	},
	methods: {
		triggerPageChangeEvent(page) {
			page = parseInt(page)
			this.$emit('pageChanged', page)
		},
		handleScroll() {
			if (!this.scrollTriggerElement || this.loading || 0 === window.scrollY || 1 + this.currentPage > this.totalPages) {
				return
			}

			if (window.innerHeight + window.scrollY >= this.scrollTriggerElement.offsetTop - this.scrollBuffer) {
				this.$emit('pageAppend', 1 + this.currentPage)
			}
		}
	},
	mounted() {
		if (this.useInfiniteScroll) {
			this.scrollTriggerElement = document.getElementById('vueEventsPluginPagination')
			window.addEventListener('scroll', this.handleScroll)
		}
	},
	unmounted() {
		this.scrollTriggerElement = null
		window.removeEventListener('scroll', this.handleScroll)
	},
}
</script>
